import { School, TrendingUp, Target, Flame } from 'lucide-react';
import type { AnalyzeNationalStats } from '../../types';

interface AnalyzeStatsBarProps {
  stats: AnalyzeNationalStats | null;
  clusterCount: number;
  topScore: number;
  isLoading: boolean;
}

export default function AnalyzeStatsBar({ stats, clusterCount, topScore, isLoading }: AnalyzeStatsBarProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-4 gap-4 mb-4">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 animate-pulse">
            <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2 mb-2" />
            <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-1/3" />
          </div>
        ))}
      </div>
    );
  }

  const cards = [
    {
      icon: <School className="h-5 w-5 text-blue-500" />,
      label: 'Total Schools',
      value: stats?.totalSchools?.toLocaleString() ?? '0',
      bg: 'bg-blue-50 dark:bg-blue-900/30',
    },
    {
      icon: <TrendingUp className="h-5 w-5 text-green-500" />,
      label: 'Blast Penetration',
      value: `${stats?.avgPenetration ?? 0}%`,
      bg: 'bg-green-50 dark:bg-green-900/30',
    },
    {
      icon: <Target className="h-5 w-5 text-orange-500" />,
      label: 'Opportunity Clusters',
      value: clusterCount.toString(),
      bg: 'bg-orange-50 dark:bg-orange-900/30',
    },
    {
      icon: <Flame className="h-5 w-5 text-red-500" />,
      label: 'Top Score',
      value: topScore.toString(),
      bg: 'bg-red-50 dark:bg-red-900/30',
    },
  ];

  return (
    <div className="grid grid-cols-4 gap-4 mb-4">
      {cards.map((card) => (
        <div key={card.label} className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 flex items-center gap-4">
          <div className={`${card.bg} rounded-lg p-3`}>{card.icon}</div>
          <div>
            <div className="text-2xl font-bold text-gray-900 dark:text-gray-100">{card.value}</div>
            <div className="text-sm text-gray-500 dark:text-gray-400">{card.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
